import type { ComponentType, SVGProps } from 'react'

import Button from '@/components/ui/button'
import CountBadge from '@/components/ui/count-badge'
import { cn } from '@/lib/utils'

interface SidebarNavItemProps {
    icon: ComponentType<SVGProps<SVGSVGElement>>
    label: string
    href?: string
    onClick?: () => void
    count?: number
    active?: boolean
    tone?: 'default' | 'quiet'
    iconClassName?: string
}

export default function SidebarNavItem({
    icon: Icon,
    label,
    href,
    onClick,
    count,
    active = false,
    tone = 'default',
    iconClassName
}: SidebarNavItemProps) {
    return (
        <li className={cn(active && 'my-0.5')}>
            <Button
                variant='nav'
                size='md'
                href={href}
                onClick={onClick}
                data-active={active}
                aria-current={active ? 'page' : undefined}
                className={cn(
                    'group h-[30px] gap-1.5 py-0 data-[active=true]:h-8',
                    tone === 'quiet' && 'text-subtle'
                )}
            >
                <Icon
                    aria-hidden
                    className={cn(
                        'text-subtle ease-power3-out group-hover:text-icon group-data-[active=true]:text-icon size-3.5 shrink-0 transition-colors duration-150',
                        iconClassName
                    )}
                />
                <span className='min-w-0 flex-1 truncate text-left'>
                    {label}
                </span>
                {count !== undefined && count > 0 && <CountBadge>{count}</CountBadge>}
            </Button>
        </li>
    )
}
